import { render } from "./ToolRequestsPage.vue?vue&type=template&id=6bd411a8&scoped=true"
import script from "./ToolRequestsPage.vue?vue&type=script&lang=js"
export * from "./ToolRequestsPage.vue?vue&type=script&lang=js"

import "./ToolRequestsPage.vue?vue&type=style&index=0&id=6bd411a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd411a8"]])

export default __exports__